export const header = {
  navigation: {
    features: 'Fonctionnalités',
    businessTypes: 'Types de Commerce',
    testimonials: 'Témoignages',
    contact: 'Contact',
    dashboard: 'Tableau de bord',
    subscription: 'Abonnement'
  },
  auth: {
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Déconnexion',
    fillForm: 'Veuillez remplir le formulaire ci-dessous',
    fullName: 'Votre Nom Complet',
    fullNamePlaceholder: 'Entrez votre nom complet',
    phone: 'Votre Téléphone',
    phonePlaceholder: '06 XX XX XX XX',
    city: 'Ville',
    selectCity: 'Choisir votre ville',
    businessType: 'Votre Type d\'Activité',
    selectBusinessType: 'Sélectionnez votre type d\'activité'
  },
  cities: {
    casablanca: 'Casablanca',
    rabat: 'Rabat',
    marrakech: 'Marrakech',
    fes: 'Fès',
    tanger: 'Tanger',
    agadir: 'Agadir',
    meknes: 'Meknès',
    oujda: 'Oujda',
    kenitra: 'Kénitra',
    tetouan: 'Tétouan',
    sale: 'Salé',
    nador: 'Nador',
    mohammedia: 'Mohammedia',
    eljadida: 'El Jadida',
    benimellal: 'Béni Mellal',
    other: 'Autre'
  },
  businessTypes: {
    epicerie: 'Epicerie',
    parapharmacie: 'Parapharmacie',
    cafe_restaurant: 'Café Restaurant',
    boulangerie_patisserie: 'Boulangerie Patisserie',
    meule: 'Meule',
    vetement: 'Vêtement',
    atelier: 'Atelier',
    service_maintenance: 'Service Maintenance'
  },
  common: {
    cancel: 'Annuler',
    send: 'Envoyer',
    sending: 'Envoi en cours...'
  },
  mobile: {
    menu: 'Ouvrir le menu'
  }
}; 